export default {
  getCookie(sKey) {
    return decodeURIComponent(document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1')) || null;
  },
  setCookie(cookieKey, cookieValue, cookieOpts) {
    let arr = [];
    let d, t;
    let cfg = {
      'expire': null,
      'path': null,
      'domain': null,
      'secure': null,
      'encode': true
    };
    Object.assign(cfg, cookieOpts);

    if (cfg.encode === true) {
      cookieValue = escape(cookieValue);
    }
    arr.push(cookieKey + '=' + cookieValue);

    if (cfg.path != null) {
      arr.push('path=' + cfg.path);
    }
    if (cfg.domain != null) {
      arr.push('domain=' + cfg.domain);
    }
    if (cfg.secure != null) {
      arr.push(cfg.secure);
    }
    if (cfg.expire != null) {
      d = new Date();
      t = d.getTime() + cfg.expire * 3600000;
      d.setTime(t);
      arr.push('expires=' + d.toGMTString());
    }
    document.cookie = arr.join(';');
  },
  removeCookie(cookieKey, cookieOpts) {
    cookieOpts = cookieOpts || {};
    cookieOpts.expire = -10;
    this.setCookie(cookieKey, '', cookieOpts);
  }
};
